import React, { useState, useEffect } from 'react'
import DocumentPreview from 'srcReact/MessengerPage/components/DocumentPreview'
import { getDescryptedMedia } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'

function FileContent({ file, isImage, isDecrypted = false }) {
  const [decryptedFile, setDecryptedFile] = useState('')
  const [currentOrientation, setCurrentOrientation] = useState('')
  const [extension, setExtension] = useState('')

  const handleImageOnLoad = (e) => {
    const img = e.target

    if (img.naturalWidth > img.naturalHeight) {
      setCurrentOrientation(styles.landscape)
    } else if (img.naturalWidth < img.naturalHeight) {
      setCurrentOrientation(styles.portrait)
    } else {
      setCurrentOrientation(styles.even)
    }
  }

  useEffect(() => {
    if (file && file.path) {
      const fileName = file.name || file.original_file_name
      setExtension(fileName.split('.').pop().toLowerCase())
      if (!isDecrypted) {
        const { url, is_original, original_tag, mime_type } = file

        //Do not decrypt document as we are not showing content of it. Just decrypt images as they are visible in carousel
        //Decrypt documents only while downloading
        getDescryptedMedia(url, isImage ? is_original : 1, original_tag, mime_type, file.id || file.file_id).then(
          (data) => setDecryptedFile(data.img)
        )
      } else {
        setDecryptedFile(file.picture)
      }
    }
  }, [file])
  return (
    <div className={`${styles.mainWithActions} `} key={file.id}>
      {isImage ? (
        <img
          className={`${styles.image} ${currentOrientation}`}
          src={decryptedFile}
          onLoad={(e) => handleImageOnLoad(e)}
        />
      ) : (
        <DocumentPreview
          decryptedFile={decryptedFile}
          className={styles.document}
          fileName={file.name}
          extension={extension}
          documentNameCSS={styles.documentName}
        />
      )}
    </div>
  )
}

export default FileContent
